import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3fe5cce6")

_pushScopeId("data-v-3fe5cce6")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "mobile__preview" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "spacer" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Intro = _resolveComponent("Intro")
  const _component_Upload = _resolveComponent("Upload")
  const _component_KeyPointSelection = _resolveComponent("KeyPointSelection")
  const _component_ColorSelection = _resolveComponent("ColorSelection")
  const _component_LayoutSelection = _resolveComponent("LayoutSelection")
  const _component_TransSlide = _resolveComponent("TransSlide")
  const _component_Congrats = _resolveComponent("Congrats")
  const _component_FinalOutput = _resolveComponent("FinalOutput")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.checkCount(1))
        ? (_openBlock(), _createBlock(_component_Intro, {
            key: 0,
            onFinished: _ctx.swapComponent
          }, null, 8, ["onFinished"]))
        : _createCommentVNode("", true),
      (_ctx.checkCount(2))
        ? (_openBlock(), _createBlock(_component_Upload, {
            key: 1,
            onFinished: _ctx.swapComponent
          }, null, 8, ["onFinished"]))
        : _createCommentVNode("", true),
      _createVNode(_Transition, {
        name: "fastfade",
        appear: ""
      }, {
        default: _withId(() => [
          (_ctx.checkCount(3))
            ? (_openBlock(), _createBlock(_component_KeyPointSelection, {
                key: 0,
                onFinished: _ctx.swapComponent,
                onAddKP: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addKeyPT($event)))
              }, null, 8, ["onFinished"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.checkCount(4))
        ? (_openBlock(), _createBlock(_component_ColorSelection, {
            key: 2,
            selectedKeypoints: _ctx.selectedKeypoints,
            onSelectColor: _ctx.selectColor,
            onFinished: _ctx.swapComponent
          }, null, 8, ["selectedKeypoints", "onSelectColor", "onFinished"]))
        : _createCommentVNode("", true),
      (_ctx.checkCount(5))
        ? (_openBlock(), _createBlock(_component_LayoutSelection, {
            key: 3,
            onSelectLayout: _ctx.selectLayout,
            onFinished: _ctx.swapComponent
          }, null, 8, ["onSelectLayout", "onFinished"]))
        : _createCommentVNode("", true),
      (_ctx.checkCount(6))
        ? (_openBlock(), _createBlock(_component_TransSlide, {
            key: 4,
            onFinished: _ctx.swapComponent
          }, null, 8, ["onFinished"]))
        : _createCommentVNode("", true),
      _createVNode(_Transition, {
        name: "fastfade",
        appear: ""
      }, {
        default: _withId(() => [
          (_ctx.checkCount(7))
            ? (_openBlock(), _createBlock(_component_Congrats, {
                key: 0,
                onFinished: _ctx.swapComponent
              }, null, 8, ["onFinished"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, {
        name: "fastfade",
        appear: ""
      }, {
        default: _withId(() => [
          (_ctx.checkCount(8))
            ? (_openBlock(), _createBlock(_component_FinalOutput, {
                key: 0,
                selectedKeypoints: _ctx.selectedKeypoints,
                selectedColor: _ctx.selectedColor,
                selectedLayout: _ctx.selectedLayout,
                onFinished: _ctx.swapComponent
              }, null, 8, ["selectedKeypoints", "selectedColor", "selectedLayout", "onFinished"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode("img", {
      class: "logo",
      src: _ctx.icons.thoth,
      alt: ""
    }, null, 8, ["src"]),
    _hoisted_3
  ]))
})